import React from 'react';
import { AccServiceBlock, AccServiceTitle, ServiceBlock, ServiceTitle } from '../styled';
import AdvantagesList from './advantagesList';
var InternetBlock = function (_a) {
    var isAccordion = _a.isAccordion, withBg = _a.withBg, isOpen = _a.isOpen, onToggle = _a.onToggle, speed = _a.speed, advantages = _a.advantages;
    return (isAccordion && advantages.length
        ? <AccServiceBlock withBg={withBg} isClosed={!isOpen} defaultOpen={isOpen} open={isOpen} toggle={onToggle} data-test='options' title={<AccServiceTitle data-test='block-title'>
                    {speed}&nbsp;Мбит/с
                </AccServiceTitle>}>
            <AdvantagesList advantages={advantages}/>
        </AccServiceBlock>
        : <ServiceBlock>
            <ServiceTitle withBg={withBg} data-test='block-title'>
                {speed}&nbsp;Мбит/с
            </ServiceTitle>
            {!!advantages.length && <AdvantagesList advantages={advantages} data-test='advantages'/>}
        </ServiceBlock>);
};
export default InternetBlock;
